import { CashRequestMiddleware } from './types'

/**
 * Moneybot is not localized yet, so it renders in English for every customer rather than mixing
 * translated chrome with English generated copy (CAES1-1024).
 */
export const MONEYBOT_LOCALE = 'en-US'

// Only Moneybot's own endpoints are pinned. Product data Moneybot renders (activity rows, balances)
// shares react-query cache entries with the rest of the app, and pinning those requests would leak
// English into non-Moneybot surfaces.
const MONEYBOT_SERVER_PATHS = ['/cash-app/goose-cash/', '/cash-app/frontdoor/get-moneybot-home']

/**
 * Asks Moneybot's endpoints for English copy. This is global rather than provided through the React
 * tree because several Moneybot requests (chat history, skills, triggered actions) call `post`
 * directly and never see context middleware. It must run after every other request middleware that
 * sets `Accept-Language`.
 */
export const moneybotLocaleRequest: CashRequestMiddleware = (request, context) => {
  if (MONEYBOT_SERVER_PATHS.some(path => context?.path?.includes(path))) {
    const headers = request.headers as Record<string, string>
    headers['Accept-Language'] = MONEYBOT_LOCALE
  }

  return request
}
